import './assets/css/App.css';
import request from '@/http/request'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import {} from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import RTLLayout from './layouts/rtl';
import {
  ChakraProvider,
  // extendTheme
} from '@chakra-ui/react';
import initialTheme from './theme/theme'; //  { themeGreen }
import { useEffect, useState } from 'react';
import storage from './utils/jeepayStorageWrapper.js'
import {useSelector, useDispatch} from 'react-redux';
import {setBalance} from '@/store/festures/balanceSlice.js';
import useFetchData from '@/hooks/fetch.js'
// Chakra imports

export default function Main() {
  // eslint-disable-next-line
  const location = useLocation();
  const isAuthenticated = !!storage.getToken();
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  const dispatch = useDispatch()
  // const fetchBalace = useFetchData({
  //   url: '/api/wym/balance',
  //   method: 'get'
  // })

  // 通过useSelector直接拿到store中定义的value
  // const {balanceVal} = useSelector((store)=>store.balance)
  // 通过useDispatch 派发事件
  // const dispatch = useDispatch()

  // useEffect(() => {
  //   // fetchBalace.then(res => {
  //   //   // alert(res)
  //   //   dispatch(setBalance(res.toFixed(2)))
  //   // }).catch(() => {})
  //   // 余额充值
  //   // request.request({
  //   //   url: '/api/mchApps',
  //   //   method: 'get',
  //   //   data: {
  //   //     pageSize: -1
  //   //   }
  //   // }).then(res => {
  //   //   // alert(res)
  //   //   console.log(res)
  //   //   return {
  //   //     appId: res.records[0].appId,
  //   //     mchOrderNo: 'M' + new Date().getTime() + Math.floor(Math.random() * (9999 - 1000) + 1000)
  //   //   }
  //   // }).then((data) => {
  //   //   request.request({
  //   //     url: '/api/wym/balance/recharge',
  //   //     method: 'post',
  //   //     data: {
  //   //       ...data,
  //   //       rechargeAmount: '0.01',
  //   //       wayCode: "WX_NATIVE",
  //   //       amount: "0.01",
  //   //       payDataType: "codeImgUrl",
  //   //       authCode: "",
  //   //       divisionMode: 0,
  //   //       orderTitle: "接口调试"
  //   //     }
  //   //   }).then(res => {
  //   //     // alert(res)
  //   //     console.log(res, 123)
  //   //   }).catch(() => {
  //   //   })
  //   // })

  //    // 余额提现
  //   //  request.request({
  //   //   url: '/api/wym/balance/withdrawal',
  //   //   method: 'post',
  //   //   data: {
  //   //     amount: 0.01
  //   //   }
  //   // }).then(res => {
  //   //   // alert(res)
  //   //   console.log(res)
  //   // }).catch(() => {
  //   // })

  //   // // 提现记录
  //   // request.request({
  //   //   url: '/api/wym/balance/withdrawal/page',
  //   //   method: 'get',
  //   //   data: {
  //   //     pageNumber: 1,
  //   //     pageSize: 10
  //   //   }
  //   // }).then(res => {
  //   //   // alert(res)
  //   //   console.log(res)
  //   // }).catch(() => {
  //   // })

  //   // // 发票记录
  //   // request.request({
  //   //   url: '/api/wym/invoice/page',
  //   //   method: 'get',
  //   //   data: {
  //   //     pageNumber: 1,
  //   //     pageSize: 10
  //   //   }
  //   // }).then(res => {
  //   //   // alert(res)
  //   //   console.log(res)
  //   // }).catch(() => {
  //   // })

  //   // // 开发票
  //   // request.request({
  //   //   url: '/api/wym/invoice/apply',
  //   //   method: 'post',
  //   //   data: {
  //   //     amount: "0.01", 
  //   //     customerName: "客户名称", 
  //   //     customerTaxId: "客户税号", 
  //   //     customerAddress: "单位地址", 
  //   //     customerPhone: "电话", 
  //   //     bankName: "开户银行名称", 
  //   //     bankAccount: "银行账户" 
  //   //   }
  //   // }).then(res => {
  //   //   // alert(res)
  //   //   console.log(res)
  //   // }).catch(() => {
  //   // })

  //   // // 余额查询
  //   // request.request({
  //   //   url: '/api/wym/balance/recharge/page',
  //   //   method: 'get',
  //   //   data: {
  //   //     pageNumber: 1,
  //   //     pageSize: 10
  //   //   }
  //   // }).then(res => {
  //   //   // alert(res)
  //   //   console.log(res)
  //   // }).catch(() => {
  //   // })

  //   // 充值记录查询
  //   // request.request({
  //   //   url: '/api/wym/balance/recharge/page',
  //   //   method: 'get',
  //   //   data: {
  //   //     pageNumber: 1,
  //   //     pageSize: 10
  //   //   }
  //   // }).then(res => {
  //   //   // alert(res)
  //   //   console.log(res)
  //   // }).catch(() => {
  //   // })

  //   // 消费记录列表
  //   // request.request({
  //   //   url: '/api/wym/pay/page',
  //   //   method: 'get',
  //   //   data: {
  //   //     pageNumber: 1,
  //   //     pageSize: 10
  //   //   }
  //   // }).then(res => {
  //   //   // alert(res)
  //   //   console.log(res)
  //   // }).catch(() => {
  //   // })
  //   // // 消费记录详情
  //   // request.request({
  //   //   url: `/api/wym/pay/P1877156905970208769`,
  //   //   method: 'get',
  //   //   data: {
  //   //   }
  //   // }).then(res => {
  //   //   // alert(res)
  //   //   console.log(res)
  //   // }).catch(() => {
  //   // })

  //    // 订单记录列表
  //   // request.request({
  //   //   url: '/api/payOrder',
  //   //   method: 'get',
  //   //   data: {
  //   //     pageNumber: 1,
  //   //     pageSize: 10
  //   //   }
  //   // }).then(res => {
  //   //   // alert(res)
  //   //   console.log(res)
  //   // }).catch(() => {
  //   // })
    
  //   // // 订单详情
  //   // request.request({
  //   //   url: `/api/payOrder/P1876993411698274306`,
  //   //   method: 'get',
  //   //   data: {
  //   //   }
  //   // }).then(res => {
  //   //   // alert(res)
  //   //   console.log(res)
  //   // }).catch(() => {
  //   // })
  // }, []);


  return (
    <ChakraProvider theme={currentTheme}>
      <Routes>
        <Route path="auth/*" element={<AuthLayout />} />
        {
          isAuthenticated ? (
            <Route
              path="admin/*"
              element={
                <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
              }
            /> 
          ) : (
            <Route path="admin/*" element={<Navigate to="/auth/sign-in" replace />} />
          )
        }
        <Route
          path="rtl/*"
          element={
            <RTLLayout theme={currentTheme} setTheme={setCurrentTheme} />
          }
        />
        <Route path="/" element={<Navigate to="/admin/profile" replace />} />
      </Routes>
    </ChakraProvider>
  );
}
